import type { AppState } from '@constants/types'
import { combineReducers } from 'redux'

import auth from './auth'
import chiller from './chiller'
import engines from './engines'
import gearbox from './gearbox'
import generators from './generators'
import history from './history'
import main from './main'
import mapConfig from './mapConfig'
import ovalMode from './ovalMode'
import propellers from './propellers'
import routeBlocker from './routeBlocker'
import rudder from './rudder'
import satAntennas from './satAntennas'
import stabilizers from './stabilizers'
import tanks from './tanks'
import threeD from './threeD'
import thruster from './thruster'
import time from './time'
import TVMode from './TVMode'
import units from './units'
import watermakers from './watermakers'
import weather from './weather'

const appReducer = combineReducers({
  main,
  history,
  propellers,
  rudder,
  gearbox,
  chiller,
  engines,
  generators,
  tanks,
  watermakers,
  stabilizers,
  thruster,
  satAntennas,
  TVMode,
  ovalMode,
  units,
  auth,
  routeBlocker,
  mapConfig,
  threeD,
  time,
  weather
})

export default function reducer (state: AppState | undefined, action: unknown) {
  // @ts-expect-error no idea about types
  return appReducer(state, action)
}
